/**
 * Created by tmorone on 2/8/2016.
 */

var Backbone = require('backbone');
var Hash = require('../helpers/hash.js');
var moment = require('moment');

/**
 * A model to hold the definition of a single collection.
 * Uses the server 'collection' api.
 * Must be initialized with a collection id.
 */
module.exports = Backbone.Model.extend( {
    urlRoot: '/api/collection/',
    /**
     * Override the fetch method to provide a success callback.
     * On success, determine if the collection is currently published, and determine the link to the icon.
     * @param options
     */
    fetch: function(options) {
        Backbone.Model.prototype.fetch.call(this, {success: function() {
            var coll_icon = Hash.MD5('collectionicon'+this.attributes.id);
            var name = "Unknown Collection";
            var now = new Date(Date.now() + new Date().getTimezoneOffset() * 60 * 1000);
            var image = "https://s3.amazonaws.com/packrat-plus-public/web_images/large-unknown.gif";
            var feat = "https://s3.amazonaws.com/packrat-plus-public/web_images/large-unknown.gif";
            var published = '';

            if(this.attributes.publish_date && this.attributes.publish_date < now) {
                published = 'Published ' + moment(this.attributes.publish_date).calendar(null, {sameDay: '[Today at] LTS', lastDay: '[Yesterday at] LTS', sameElse: 'LLL'});
                name = this.attributes.name;
                image = "https://s3.amazonaws.com/packrat-plus-live/collections/" + coll_icon;
                //feat = "https://s3.amazonaws.com/packrat-plus-live/feats/" + Hash.MD5('collectionfeat'+this.attributes.id);
            }

            this.set('name',name);
            this.set('published',published);
            this.set('icon',image);
            //this.set('feat',feat);
        }.bind(this)});
    }
});